import { render, staticRenderFns } from "./FileDetailsPanel.vue?vue&type=template&id=8550e2cc"
import script from "./FileDetailsPanel.vue?vue&type=script&lang=js"
export * from "./FileDetailsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports